import React from 'react';
import { useLocation } from 'react-router-dom';
import VendorOnboardingSubmitted from './VendorOnboardingSubmitted';

const VendorOnboardingSubmittedPage = () => {
  const location = useLocation();
  return (
    <VendorOnboardingSubmitted
      isEdit={Boolean(location.state?.isEdit)}
      pendingApproval={Boolean(location.state?.pendingApproval)}
    />
  );
};

export default VendorOnboardingSubmittedPage;
